import { activity } from './resources/activity';
import { attempt } from './resources/attempt';
import { flashcard } from './resources/flashcard';
import { feedback } from './resources/feedback';
import { quiz } from './resources/quiz';
import { summary } from './resources/summary';
import { Sdk } from './sdk';
import { dashboard } from './resources/dashboard';

export const resources = {
  activity,
  flashcard,
  feedback,
  quiz,
  summary,
  attempt,
  dashboard,
};
export const sdk = Sdk.fromResources(resources);

export type WidgetSdk = Sdk<typeof resources>;
export * from './types';
